export default __webpack_public_path__ + "static/stone-1920x1080-e542a9c5e2d9e8c1b7fb7806eb0b5ef7.png";